// extracted by mini-css-extract-plugin
module.exports = {"root":"Faq_root__1nP99","header":"Faq_header__eKcbZ","section":"Faq_section__CpyTK"};